export type SourceDef = (url: string, options: { [key: string]: any }) => any;

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

export type Resource = [HttpMethod, string];
